const GOOGLE_CLIENT_ID_ENV = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const API_BASE_URL_ENV = import.meta.env.VITE_API_BASE_URL;

if (!GOOGLE_CLIENT_ID_ENV) {
  throw new Error('VITE_GOOGLE_CLIENT_ID is not defined');
}

if (!API_BASE_URL_ENV) {
  throw new Error('VITE_API_BASE_URL is not defined');
}

export const GOOGLE_CLIENT_ID = GOOGLE_CLIENT_ID_ENV;
export const API_BASE_URL = API_BASE_URL_ENV;
